import type { Media } from "./types";

export function selectDiscoveryPhoto(media: Media[]): string | undefined {
  return (
    media.find((item) => item.kind === "photo" && !item.locked && item.url)
      ?.url ??
    media.find((item) => item.kind === "avatar" && item.url)?.url ??
    undefined
  );
}
